import { common } from './common.service';

export const userSettingsServices = {
    get,
    post,
}

/**
 * Fetch user settings
 * @returns {Promise} - A promise that resolves to the user settings
 */
function get() {
    const url = 'User/settings';
    return common.fetchAPI({ url, method: 'GET', token: true });
};

/**
 * Update user settings
 * @param {*} settings 
 * @returns {Promise} - A promise that resolves to the updated user settings
 */
function post(settings) {
    const url = 'User/settings';
    return common.fetchAPI({ url, method: 'POST', data: {settings}, token: true });
};
